import { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import Footer from "../components/Footer";

/* ═══════════════════════════════════════════════════════════════
   MES COCONEUSES — Page dédiée
   Style : immersif, haut de gamme, orientant sans forcer
   ═══════════════════════════════════════════════════════════════ */

const COCONEUSES = [
  {
    id: "valerie",
    name: "Valérie",
    signature: "Apaisement",
    subtitle: "Yoga sensible & vibrant",
    photo: "https://customer-assets.emergentagent.com/job_6603108a-de24-4f36-aea5-adcbc13cbf2a/artifacts/as2yuj7o_WhatsApp%20Image%202026-02-01%20at%2018.53.40.jpeg",
    bio: "Valérie ouvre un espace où le corps peut enfin être écouté, respecté, et aimé dans toutes ses dimensions.",
    link: "/valouse/coconeuses/valerie",
  },
  {
    id: "deborah",
    name: "Deborah",
    signature: "Clarté",
    subtitle: "Éveil · Harmonisation · Paix intérieure · Transformation",
    photo: "https://customer-assets.emergentagent.com/job_6603108a-de24-4f36-aea5-adcbc13cbf2a/artifacts/6r9rpmdm_DSC01487.jpg",
    bio: "Deborah est un pont entre l'universel et l'intime, là où quelque chose peut se réaligner en profondeur.",
    link: "/valouse/coconeuses/deborah",
  },
  {
    id: "emma",
    name: "Emmanuelle · Emma",
    signature: "Douceur",
    subtitle: "Vulnérabilité · Authenticité · Guidance · Harmonisation",
    photo: "https://customer-assets.emergentagent.com/job_6603108a-de24-4f36-aea5-adcbc13cbf2a/artifacts/wfrtnvi0_DSC07276.jpg",
    bio: "Emma déploie une présence douce et profondément sensible, où les masques peuvent naturellement tomber.",
    link: "/valouse/coconeuses/emma",
  },
  {
    id: "ame-diva",
    name: "Âme Diva",
    signature: "Expression",
    subtitle: "La voix comme médecine · Le chant comme passage",
    photo: "https://customer-assets.emergentagent.com/job_6603108a-de24-4f36-aea5-adcbc13cbf2a/artifacts/2d7ag7eo_DSC00736.jpg",
    bio: "Âme Diva ouvre un espace où la voix se libère et retrouve sa pleine puissance.",
    link: "/valouse/coconeuses/ame-diva",
  },
  {
    id: "maite",
    name: "Maïté",
    signature: "Ancrage",
    subtitle: "Sagesse incarnée · Mémoire du corps · Libération profonde",
    photo: "https://customer-assets.emergentagent.com/job_6603108a-de24-4f36-aea5-adcbc13cbf2a/artifacts/64bo4q6r_DSC00675.jpg",
    bio: "Maïté incarne une présence ancrée et profonde, où le corps et la mémoire peuvent enfin se relâcher.",
    link: "/valouse/coconeuses/maite",
  },
  {
    id: "stephanie",
    name: "Stéphanie",
    signature: "Précision",
    subtitle: "Kinésithérapeute, ostéopathe & Chi Nei Tsang",
    photo: "https://customer-assets.emergentagent.com/job_6603108a-de24-4f36-aea5-adcbc13cbf2a/artifacts/v301k76m_WhatsApp%20Image%202026-02-08%20at%2017.22.12.jpeg",
    bio: "Stéphanie écoute, ressent et relie, accompagnant le corps vers un équilibre global et respectueux de son rythme.",
    link: "/valouse/coconeuses/stephanie",
  },
  {
    id: "heather",
    name: "Heather",
    signature: "Connexion",
    subtitle: "Gardienne du lien entre Ciel et Terre",
    photo: "https://customer-assets.emergentagent.com/job_6603108a-de24-4f36-aea5-adcbc13cbf2a/artifacts/koq18pg1_Copy%20of%20DSC01853.jpg",
    bio: "Heather ouvre un espace de reconnexion où le visible et l'invisible se rencontrent avec douceur.",
    link: "/valouse/coconeuses/heather",
  },
];

const ORIENTATIONS = [
  { text: "Te reconnecter à ton corps", name: "Valérie", id: "valerie" },
  { text: "Apaiser ce qui est en mouvement en toi", name: "Deborah", id: "deborah" },
  { text: "Retrouver une douceur, une sécurité intérieure", name: "Emma", id: "emma" },
  { text: "Libérer ta voix, ton expression", name: "Âme Diva", id: "ame-diva" },
  { text: "Traverser en profondeur, avec ancrage", name: "Maïté", id: "maite" },
  { text: "Recevoir un soin précis, corporel et énergétique", name: "Stéphanie", id: "stephanie" },
  { text: "Relier le visible et l'invisible", name: "Heather", id: "heather" },
];

/* ── Profil alternant ── */
const Profile = ({ coconeuse, reverse }) => (
  <div
    id={`profil-${coconeuse.id}`}
    className={`flex flex-col ${reverse ? "md:flex-row-reverse" : "md:flex-row"} gap-8 md:gap-14 items-center`}
    data-testid={`profil-${coconeuse.id}`}
  >
    <div className="w-full md:w-1/2 overflow-hidden rounded-2xl">
      <img
        src={coconeuse.photo}
        alt={coconeuse.name}
        className="w-full aspect-[4/5] object-cover"
        loading="lazy"
      />
    </div>
    <div className="w-full md:w-1/2 space-y-5 text-center md:text-left">
      <h3 className="font-serif text-2xl sm:text-3xl text-[#3F2A24]">
        {coconeuse.name}
      </h3>
      {coconeuse.signature && (
        <p className="font-serif text-sm italic text-[#3F2A24]/40">
          {coconeuse.signature}
        </p>
      )}
      <p className="text-xs tracking-[0.08em] uppercase text-[#C5A059]">
        {coconeuse.subtitle}
      </p>
      <div className="w-10 h-[1px] bg-[#3F2A24]/15 mx-auto md:mx-0" />
      <p className="font-serif text-sm sm:text-base text-[#3F2A24]/70 leading-[2] max-w-md" style={{ textWrap: "balance" }}>
        {coconeuse.bio}
      </p>
      <Link
        to={coconeuse.link}
        className="inline-block mt-2 text-xs tracking-[0.15em] uppercase text-[#3F2A24] underline decoration-[#C5A059]/50 underline-offset-4 hover:text-[#C5A059] transition-colors"
        data-testid={`link-${coconeuse.id}`}
      >
        J'entre dans son univers
      </Link>
    </div>
  </div>
);

/* ── Respiration entre profils ── */
const Breathing = ({ lines }) => (
  <div className="py-16 sm:py-24 text-center">
    <div className="max-w-md mx-auto space-y-4 font-serif text-base sm:text-lg text-[#3F2A24]/50 italic leading-[2.2]">
      {lines.map((l, i) => (
        <p key={i}>{l}</p>
      ))}
    </div>
  </div>
);

/* ═══════════════════════════════════════════════════════════════ */
const MesCoconeuses = () => {
  const location = useLocation();

  useEffect(() => {
    document.title = "Les Coconeuses | COCON Valouse – Celles qui portent le cercle";
    // Ne pas scroller en haut si un hash est présent (navigation intelligente)
    if (!location.hash) {
      window.scrollTo(0, 0);
    }
  }, [location.hash]);

  const scrollTo = (id) => {
    document.getElementById(`profil-${id}`)?.scrollIntoView({ behavior: "smooth", block: "center" });
  };

  return (
    <div className="min-h-screen bg-[#EDE6DA] text-[#3F2A24]" data-testid="coconeuses-page">

      {/* ═══ HERO — PHOTO DE GROUPE ═══ */}
      <section data-testid="group-photo">
        <img
          src="https://customer-assets.emergentagent.com/job_ac714315-3cd2-433b-a5fc-ee465f63f309/artifacts/zfzwmvr8_coconeuses.jpg"
          alt="Les coconeuses réunies sous l'arbre à Valouse"
          className="w-full object-cover"
          style={{ aspectRatio: "21/10", minHeight: "320px", maxHeight: "600px" }}
        />
      </section>

      {/* ═══ SECTION 1 — INTRO ═══ */}
      <section className="py-20 sm:py-28 px-6 bg-[#8d7a6b]">
        <div className="max-w-4xl mx-auto space-y-10">
          <Link
            to="/"
            className="text-xs tracking-[0.15em] text-[#F3E5CF]/50 hover:text-[#F3E5CF] transition-colors"
            data-testid="back-to-home"
          >
            ← Retour
          </Link>

          <div className="max-w-lg mx-auto text-center space-y-6">
            <p className="text-[10px] sm:text-xs tracking-[0.3em] uppercase text-[#F3E5CF]/50">
              Le cercle
            </p>
            <h1 className="font-serif text-2xl sm:text-3xl md:text-4xl text-[#F3E5CF]">
              Les Coconeuses
            </h1>
            <p className="font-serif text-base sm:text-lg text-[#F3E5CF]/60 italic">
              Celles qui portent le cercle
            </p>
          </div>

          <div className="w-12 h-[1px] bg-[#C5A059]/20 mx-auto" />

          <div className="max-w-lg mx-auto text-center font-serif text-base sm:text-lg text-[#F3E5CF]/75 leading-[2.4] space-y-6">
            <p>
              COCON ne repose pas sur une méthode.
              <br />Il repose sur des présences.
            </p>
            <p>
              Des femmes qui tiennent l'espace.
              <br />Qui ressentent.
              <br />Qui accompagnent sans projeter.
            </p>
            <p>
              Chacune avec sa médecine.
              <br />Chacune avec sa manière d'ouvrir.
            </p>
          </div>

          <div className="h-16 sm:h-24" />

        </div>
      </section>

      {/* Texte sous intro */}
      <section className="py-16 sm:py-24 px-6 bg-[#EDE6DA]">
        <div className="max-w-md mx-auto text-center space-y-3">
          <p className="font-serif text-base sm:text-lg text-[#3F2A24]/50 italic leading-[2]">
            Un cercle.
          </p>
          <p className="font-serif text-base sm:text-lg text-[#3F2A24]/50 italic leading-[2]">
            Pas une addition de pratiques.
          </p>
        </div>
      </section>
      <section className="py-20 sm:py-28 px-6" data-testid="orientation-section">
        <div className="max-w-lg mx-auto text-center space-y-14">
          <h2 className="font-serif text-xl sm:text-2xl text-[#3F2A24]">
            Si tu viens pour…
          </h2>

          <div className="space-y-8">
            {ORIENTATIONS.map((o, i) => (
              <div key={i} className="space-y-1">
                <p className="font-serif text-sm sm:text-base text-[#3F2A24]/60 italic">
                  {o.text}
                </p>
                <button
                  onClick={() => scrollTo(o.id)}
                  className="text-sm tracking-[0.15em] text-[#C5A059] hover:text-[#3F2A24] transition-colors cursor-pointer bg-transparent border-none"
                  data-testid={`orient-${o.id}`}
                >
                  → {o.name}
                </button>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ═══ SECTION 4 — PROFILS (ordre alphabétique) ═══ */}
      <section className="py-20 sm:py-28 px-6" data-testid="profiles-section">
        <div className="max-w-4xl mx-auto space-y-0">

          {/* Âme Diva */}
          <Profile coconeuse={COCONEUSES[3]} reverse={false} />

          <div className="h-20 sm:h-28" />

          {/* Deborah */}
          <Profile coconeuse={COCONEUSES[1]} reverse={true} />

          <div className="h-20 sm:h-28" />

          {/* Emmanuelle · Emma */}
          <Profile coconeuse={COCONEUSES[2]} reverse={false} />

          {/* ── Respiration 1 ── */}
          <Breathing
            lines={[
              "Ici, rien n'est imposé.",
              "Tout est proposé.",
            ]}
          />

          {/* Heather */}
          <Profile coconeuse={COCONEUSES[6]} reverse={true} />

          <div className="h-20 sm:h-28" />

          {/* Maïté */}
          <Profile coconeuse={COCONEUSES[4]} reverse={false} />

          {/* ── Respiration 2 ── */}
          <Breathing
            lines={[
              "Tu choisis ce qui résonne.",
              "Et parfois, c'est ce que tu n'attendais pas.",
            ]}
          />

          {/* Stéphanie */}
          <Profile coconeuse={COCONEUSES[5]} reverse={true} />

          <div className="h-20 sm:h-28" />

          {/* Valérie */}
          <Profile coconeuse={COCONEUSES[0]} reverse={false} />

        </div>
      </section>

      {/* ═══ SECTION 6 — FIN DE PAGE ═══ */}
      <section className="py-24 sm:py-36 px-6 bg-[#8d7a6b]" data-testid="coconeuses-closing">
        <div className="max-w-lg mx-auto text-center space-y-12">
          <div className="font-serif text-base sm:text-lg text-[#F3E5CF]/75 leading-[2.4] space-y-6">
            <p>Tu n'as rien à choisir maintenant.</p>
            <p className="text-[#F3E5CF] italic">Juste sentir.</p>
            <p>
              Et si quelque chose en toi reconnaît ce cercle,
              <br />alors la suite est déjà en train de s'écrire.
            </p>
          </div>

          <div className="w-10 h-[1px] bg-[#C5A059]/20 mx-auto" />

          {/* ═══ CONSERVATION TEMPORAIRE — ancien bouton CTA ═══
          <Link
            to="/valouse#formules"
            className="inline-flex items-center justify-center px-12 py-5 rounded-full bg-[#C5A059]/80 text-[#3F2A24] text-xs tracking-[0.2em] uppercase font-medium hover:bg-[#C5A059] transition-colors duration-500"
            data-testid="cta-choisir-experience"
          >
            Je choisis mon expérience
          </Link>
          ═══ FIN CONSERVATION TEMPORAIRE ═══ */}
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default MesCoconeuses;
